import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [jobSeekersDropdown, setJobSeekersDropdown] = useState(false);
  const [employersDropdown, setEmployersDropdown] = useState(false);
  const location = useLocation();

  // Check if we're on the home page
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setJobSeekersDropdown(false);
    setEmployersDropdown(false);
  }, [location]);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className={`navbar ${scrolled || !isHomePage ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
        <img src="/images/jwcs-logo.png" alt="Joy Worldwide Consultancy Logo" className="logo-image" />
          <div className="navbar-logo-text">
            <span className="navbar-logo-top">JOY WORLDWIDE</span>
            <span className="navbar-logo-bottom">CONSULTANCY SERVICES</span>
          </div>
        </Link>

        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
            Home
          </Link>
          <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>
            About
          </Link>

          <Link to="/services" className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`}>
            Services
          </Link>

          <div
            className="nav-item dropdown"
            onMouseEnter={() => setEmployersDropdown(true)}
            onMouseLeave={() => setEmployersDropdown(false)}
          >
            <span className={`nav-link ${location.pathname.includes('/for-employers') || location.pathname.includes('/employer-faqs') ? 'active' : ''}`}>
              For Employers <FaChevronDown className="dropdown-icon" />
            </span>
            <div className={`dropdown-menu ${employersDropdown ? 'show' : ''}`}>
              <Link to="/for-employers" className="dropdown-link">Start Hiring</Link>
              <Link to="/employer-faqs" className="dropdown-link">Employer FAQs</Link>
            </div>
          </div>
          <div
            className="nav-item dropdown"
            onMouseEnter={() => setJobSeekersDropdown(true)}
            onMouseLeave={() => setJobSeekersDropdown(false)}
          >
            <span className={`nav-link ${location.pathname.includes('/for-job-seekers') || location.pathname.includes('/candidate-faqs') ? 'active' : ''}`}>
              For Job Seekers <FaChevronDown className="dropdown-icon" />
            </span>
            <div className={`dropdown-menu ${jobSeekersDropdown ? 'show' : ''}`}>
              <Link to="/for-job-seekers" className="dropdown-link">Submit Your CV</Link>
              <Link to="/candidate-faqs" className="dropdown-link">Candidate FAQs</Link>
            </div>
          </div>
          <Link to="/careers" className={`nav-link ${location.pathname === '/careers' ? 'active' : ''}`}>
            Careers
          </Link>
          <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>
            Contact
          </Link>
        </div>

        <div className="navbar-spacer"></div>

        <div className="menu-icon" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
